<div #canvasWrapper class="w-full">
  <canvas #chart baseChart [data]="lineChartData" [options]="lineChartOptions" type="line"></canvas>
</div>
